const useLinkStyle = (disabled = false) => {
    return {
        fontSize: '13px',
        background: 'none',
        border: 'none',
        color: (theme) => (!disabled ? theme.palette.primary.main : theme.palette.text.disabled),
        cursor: !disabled ? 'pointer' : 'default',
        margin: 0,
        padding: 0,

        '&:hover, &:focus': {
            textDecoration: !disabled ? 'underline' : 'none',
        },
    };
};

export default useLinkStyle;
